const countries = [
  { value: 'US', name: 'United States' },
  { value: 'CA', name: 'Canada' },
];

export default countries;
